// services/GetUserData.js
import {jwtDecode} from 'jwt-decode';

export const getUserData = () => {
    const token = localStorage.getItem('token-fornecedor');
    if (!token) return null;

    try {
        return jwtDecode(token);
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};
